import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { CustomerApi, RejectedApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null
};

const CustomerSlice = createSlice({
  name: 'Customer',
  initialState,
  reducers: {
    setCustomerGrid(state, action) {
      state.list_data = action.payload;
    },
    setCustomerView(state, action) {
      state.view_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Customer List
export const getCustomerList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: CustomerApi?.customerList,
      method: 'post',
      payload: data
    });
    // console.log('res cusomter list', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCustomerGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCustomerGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Customer List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Customer List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Customer view
export const getCustomerView = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: CustomerApi?.customerView,
      method: 'post',
      payload: data
    });
    console.log('res cusomter view', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCustomerView(res?.data ? res?.data?.summary?.customer : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCustomerView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Customer view failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Customer view exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setCustomerGrid, setCustomerView } = CustomerSlice.actions;
export default CustomerSlice.reducer;
